// Sync state machine; values double as CSS class suffixes in App.vue.
export const SYNC_STATUS = {
    NOT_SYNCED: 'not_synced',
    SYNCING: 'syncing',
    GET_ACTIONABLE: 'getActionable',
    PROCESSING: 'processing',
    SYNCED: 'synced',
};
